import { render, staticRenderFns } from "./customerManagement.vue?vue&type=template&id=5f7c117b&scoped=true"
import script from "./customerManagement.vue?vue&type=script&lang=js"
export * from "./customerManagement.vue?vue&type=script&lang=js"
import style0 from "./customerManagement.vue?vue&type=style&index=0&id=5f7c117b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7c117b",
  null
  
)

export default component.exports